import { createFeatureSelector, createSelector } from '@ngrx/store'

import { IQuarterlyDashboardState, quarterlyDashboardFeatureKey } from './quarterly-dashboard.state'

export const selectQuarterlyDashboard = createFeatureSelector<IQuarterlyDashboardState>(quarterlyDashboardFeatureKey)

// quarter
export const selectQuarterlyDashboardQuarter = createSelector([selectQuarterlyDashboard], state => state.quarter)

export const selectQuarterlyDashboardQuarterInRequest = createSelector(
  [selectQuarterlyDashboardQuarter],
  state => state.inRequest
)

export const selectQuarterlyDashboardQuarterError = createSelector(
  [selectQuarterlyDashboardQuarter],
  state => state.error
)

export const selectQuarterlyDashboardQuarterData = createSelector(
  [selectQuarterlyDashboardQuarter],
  state => state.data
)

export const selectQuarterlyDashboardQuarterEffective = createSelector(
  [selectQuarterlyDashboardQuarter],
  state => state.effective
)

export const selectQuarterlyDashboardQuarterSelected = createSelector(
  [selectQuarterlyDashboardQuarter],
  state => state.selected
)

// market cap
export const selectQuarterlyDashboardMktCap = createSelector([selectQuarterlyDashboard], state => state.mktCap)

export const selectQuarterlyDashboardMktCapInRequest = createSelector(
  [selectQuarterlyDashboardMktCap],
  state => state.inRequest
)

export const selectQuarterlyDashboardMktCapError = createSelector(
  [selectQuarterlyDashboardMktCap],
  state => state.error
)

export const selectQuarterlyDashboardMktCapData = createSelector([selectQuarterlyDashboardMktCap], state => state.data)

export const selectQuarterlyDashboardMktCapSortBy = createSelector(
  [selectQuarterlyDashboardMktCap],
  state => state.sortBy
)

export const selectQuarterlyDashboardMktCapOrder = createSelector(
  [selectQuarterlyDashboardMktCap],
  state => state.order
)

// sector
export const selectQuarterlyDashboardSector = createSelector([selectQuarterlyDashboard], state => state.sector)

export const selectQuarterlyDashboardSectorInRequest = createSelector(
  [selectQuarterlyDashboardSector],
  state => state.inRequest
)

export const selectQuarterlyDashboardSectorError = createSelector(
  [selectQuarterlyDashboardSector],
  state => state.error
)

export const selectQuarterlyDashboardSectorData = createSelector([selectQuarterlyDashboardSector], state => state.data)

export const selectQuarterlyDashboardSectorSortBy = createSelector(
  [selectQuarterlyDashboardSector],
  state => state.sortBy
)

export const selectQuarterlyDashboardSectorOrder = createSelector(
  [selectQuarterlyDashboardSector],
  state => state.order
)

// sector top 500
export const selectQuarterlyDashboardSectorTop500 = createSelector(
  [selectQuarterlyDashboard],
  state => state.sectorTop500
)

export const selectQuarterlyDashboardSectorTop500InRequest = createSelector(
  [selectQuarterlyDashboardSectorTop500],
  state => state.inRequest
)

export const selectQuarterlyDashboardSectorTop500Error = createSelector(
  [selectQuarterlyDashboardSectorTop500],
  state => state.error
)

export const selectQuarterlyDashboardSectorTop500Data = createSelector(
  [selectQuarterlyDashboardSectorTop500],
  state => state.data
)

export const selectQuarterlyDashboardSectorTop500SortBy = createSelector(
  [selectQuarterlyDashboardSectorTop500],
  state => state.sortBy
)

export const selectQuarterlyDashboardSectorTop500Order = createSelector(
  [selectQuarterlyDashboardSectorTop500],
  state => state.order
)

// view mode
export const selectQuarterlyDashboardViewMode = createSelector([selectQuarterlyDashboard], state => state.viewMode)
